import React, { Fragment, useState } from "react";
import { useScreenShare } from "@100mslive/react-sdk";
import {
  PdfShare,
  ScreenShare,
  StarIcon,
  VerticalMenuIcon,
} from "@100mslive/react-icons";
import {
  Box,
  Button,
  Dropdown,
  Flex,
  IconButton,
  Text,
  Tooltip,
} from "@100mslive/react-ui";
import { ShareMenuIcon } from "../ScreenShare";
import { PDFFileOptions } from "./pdfFileOptions";

const MODALS = {
  SHARE: "share",
  SCREEN_SHARE: "screenShare",
  PDF_SHARE: "pdfShare",
};

export function ShareScreenOptions() {
  const [openModals, setOpenModals] = useState(new Set());
  const { amIScreenSharing } = useScreenShare();
  const updateState = (modalName, value) => {
    setOpenModals(modals => {
      const copy = new Set(modals);
      if (value) {
        copy.add(modalName);
      } else {
        copy.delete(modalName);
      }
      return copy;
    });
  };
  const { toggleScreenShare } = useScreenShare();
  return (
    <Fragment>
      <Dropdown.Root
        open={openModals.has(MODALS.SHARE)}
        onOpenChange={value => updateState(MODALS.SHARE, value)}
      >
        <Dropdown.Trigger
          asChild
          data-testid="sharing_btn"
          disabled={amIScreenSharing}
        >
          <ShareMenuIcon disabled={amIScreenSharing}>
            <Tooltip title="Chia sẻ">
              <Box>
                <VerticalMenuIcon />
              </Box>
            </Tooltip>
          </ShareMenuIcon>
        </Dropdown.Trigger>
        <Dropdown.Content
          sideOffset={5}
          css={{
            w: "$96",
            maxHeight: "$96",
            p: 0,
          }}
        >
          <Dropdown.Item
            css={{
              flexDirection: "column",
              alignItems: "flex-start",
              px: "$10",
              pt: "$10",
              pb: "$6",
              "&:hover": {
                bg: "$transparent",
                cursor: "default",
              },
            }}
          >
            <Text variant="h6">Bắt đầu chia sẻ</Text>
            <Text variant="sm">Chọn nội dung bạn muốn chia sẻ</Text>
          </Dropdown.Item>
          <Dropdown.Item
            css={{
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "$8",
              px: "$10",
              py: "$6",
              "&:hover": {
                bg: "$transparent",
                cursor: "default",
              },
            }}
          >
            <Flex
              direction="column"
              align="center"
              css={{
                gap: "$6",
              }}
            >
              <IconButton
                as="div"
                onClick={() => toggleScreenShare()}
                css={{
                  p: "$6",
                  display: "flex",
                  justifyContent: "center",
                  border: "1px solid $grayDefault",
                  r: "$2",
                  bg: "$surfaceLighter",
                  pb: "0",
                }}
              >
                <ScreenShare
                  width="100%"
                  height="100%"
                  style={{
                    borderTopLeftRadius: "$0",
                    borderTopRightRadius: "$0",
                  }}
                />
              </IconButton>
              <Flex direction="column" align="center">
                <Text variant="body2">Chia sẻ màn hình</Text>
                <Text
                  variant="caption"
                  css={{
                    c: "$textDisabled",
                    textAlign: "center",
                  }}
                >
                  Chia sẻ tab, cửa sổ hoặc toàn bộ màn hình của bạn
                </Text>
              </Flex>
            </Flex>
            <Flex
              direction="column"
              align="center"
              css={{
                gap: "$6",
              }}
            >
              <IconButton
                onClick={() => {
                  updateState(MODALS.PDF_SHARE, true);
                }}
                disabled={amIScreenSharing}
                css={{
                  p: "$6",
                  display: "flex",
                  justifyContent: "center",
                  border: "$grayDefault 1px solid",
                  r: "$2",
                  bg: "$surfaceLight",
                  pb: "0",
                }}
              >
                <PdfShare
                  width="100%"
                  height="100%"
                  style={{
                    borderTopLeftRadius: "$0",
                    borderTopRightRadius: "$0",
                  }}
                />
                <Flex
                  direction="row"
                  css={{
                    position: "absolute",
                    top: "29%",
                    left: "54%",
                    padding: "$2 $4",
                    r: "$2",
                    bg: "$primaryLight",
                    zIndex: "2",
                  }}
                >
                  <IconButton
                    css={{
                      w: "$10",
                      h: "$8",
                      "&:hover": {
                        bg: "$transparent !important",
                        border: "none",
                      },
                    }}
                  >
                    <StarIcon />
                  </IconButton>
                  <Text
                    variant="xs"
                    css={{
                      fontWeight: "$semiBold",
                      c: "$white",
                      pr: "$4",
                    }}
                  >
                    Mới
                  </Text>
                </Flex>
              </IconButton>
              <Flex direction="column" align="center">
                <Text variant="body2">Chia sẻ PDF</Text>
                <Text
                  variant="caption"
                  css={{
                    c: "$textDisabled",
                    textAlign: "center",
                  }}
                >
                  Chú thích, vẽ hình và hơn thế nữa trên PDF
                </Text>
              </Flex>
            </Flex>
          </Dropdown.Item>
          <Dropdown.Item
            css={{
              px: "$10",
              pb: "$10",
              pt: "$6",
              "&:hover": {
                bg: "$transparent",
                cursor: "default",
              },
            }}
          >
            <Button
              variant="standard"
              outlined
              type="submit"
              onClick={() => {
                updateState(MODALS.SHARE, false);
              }}
              data-testid="share_btn"
              css={{
                w: "100%",
              }}
            >
              Hủy bỏ
            </Button>
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Root>
      {openModals.has(MODALS.PDF_SHARE) && (
        <PDFFileOptions
          onOpenChange={value => updateState(MODALS.PDF_SHARE, value)}
        />
      )}
    </Fragment>
  );
}
